module.exports = __webpack_public_path__ + "img/scene1@2x.1889f3cc.png";